/* eslint-disable @typescript-eslint/no-explicit-any */
import { Component, Inject } from '@angular/core';

import { CrudService } from '../../services/crud.service';
import { TableExpansionBaseTemplate } from './table-expansion-base.template';

@Component({
  template: ''
})
export class TableExpansionTemplate extends TableExpansionBaseTemplate {
  constructor(
    @Inject(String) private name: string,
    private service: CrudService
  ) {
    super();
  }
}
